// extracted by mini-css-extract-plugin
export default {"welcome-section":"VideoTutorials_welcome-section__geF4F","video-card-container":"VideoTutorials_video-card-container__rHaMz"};